import React, { FC } from 'react';
import { withTranslation, WithTranslation } from '@wix/yoshi-flow-editor';

type Props = {
  value: string;
  dataHook: string;
  role?: string;
  className?: string;
};

const Duration: FC<Props & WithTranslation> = ({
  value,
  dataHook,
  t,
  role,
  className,
}) => {
  if (!value) {
    return null;
  }

  return (
    <span
      aria-label={t('widget.a11y.video.duration', { value })}
      data-hook={dataHook}
      className={className}
      role={role}
    >
      <span aria-hidden="true">{value}</span>
    </span>
  );
};

export default withTranslation()(Duration);
